module.exports = __webpack_public_path__ + "img/vision_background.dfddaf4d.png";